import httpClient from '../../httpClient';

/**
 * 회원가입 요청
 * @typedef {Object} obj
 * @param {string} email - user email
 * @param {string} password - user password
 * @param {string} name - user name
 * @param {string} companyName - compnay name
 * @param {string} inviteUser - inivate UserName
 * @param {string} countryCode - Country code
 * @param {string} authCode - email auth Code
 */
function userSignup({ email, password, name, companyName, inviteUser, countryCode, authCode }) {
  return httpClient({
    url: '/user/signup',
    method: 'POST',
    data: {
      email,
      password,
      name,
      company_name: companyName,
      inviteUser,
      countryCode,
      authCode,
    },
  });
}

export default userSignup;
